import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import CatalogDetails from '../../components/CatalogDetails/CatalogDetails'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const CatalogDetailsPage = () => {
    return (
        <>
            <Helmet>
                <title>Contract Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <CatalogDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default CatalogDetailsPage